import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type ChangeEvent, type MouseEvent, useState } from 'react';
import { REPORT_REASONS } from '@/features/listing/constants/listing-report-constants';
import { type Listing } from '@/features/listing/types/listing-types';
import sendUserReport from '@/features/user/requests/send-user-report';
import { type UserReportType } from '@/features/user/types/user-report-types';
import { type User } from '@/features/user/types/user-types';
import Button from '@/ui/button/button';
import Toggle from '@/ui/form-elements/toggle/toggle';
import { type ModalOldProps } from '@/ui/modal-old/modal-old';
import ModalOld from '@/ui/modal-old/modal-old';
import styles from './listing-report-modal.module.scss';
interface ListingReportModalProps extends ModalOldProps {
  userId: User['id'];
  listingId?: Listing['id'];
}
export default function ListingReportModal(props) {
  const $ = _c(41);
  const {
    isActive,
    listingId,
    onClose,
    userId
  } = props;
  const listingReportModalTranslations = useTranslations("listing.modal.report");
  const actionsTranslations = useTranslations("global.actions");
  const [message, setMessage] = useState("");
  const [selectedReason, setSelectedReason] = useState("CommercialPosting");
  const [isSuccessSent, setIsSuccessSent] = useState(false);
  const [isSending, setIsSending] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = event => {
      setMessage(event.target.value);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleMessageChange = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event_0 => {
      setSelectedReason(event_0.target.value as UserReportType);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleReportReasonChange = t1;
  let t2;
  if ($[2] !== listingId || $[3] !== message || $[4] !== onClose || $[5] !== selectedReason || $[6] !== userId) {
    t2 = event_1 => {
      event_1.preventDefault();
      event_1.stopPropagation();
      setIsSending(true);
      const text = listingId ? `[Listing ID: ${String(listingId)}] - ${message}` : `[User report] - ${message}`;
      sendUserReport({
        reportText: text,
        reportType: selectedReason,
        userId
      }).then(() => {
        setMessage("");
        setIsSuccessSent(true);
        setTimeout(() => {
          onClose();
        }, 2000);
      }).catch(_temp).finally(() => {
        setIsSending(false);
      });
    };
    $[2] = listingId;
    $[3] = message;
    $[4] = onClose;
    $[5] = selectedReason;
    $[6] = userId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleMessageSend = t2;
  let t3;
  if ($[8] !== listingReportModalTranslations) {
    t3 = listingReportModalTranslations("title");
    $[8] = listingReportModalTranslations;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <p className={styles.listingReportModal_title}>{t3}</p>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== listingReportModalTranslations || $[13] !== selectedReason) {
    t5 = REPORT_REASONS.map(t6 => {
      const {
        translateToken,
        type
      } = t6;
      return <Toggle onChange={handleReportReasonChange} type="radio" id={type} name="report-reason" value={type} checked={selectedReason === type} variant="button" key={type}>{listingReportModalTranslations(`report-options.${translateToken}`)}</Toggle>;
    });
    $[12] = listingReportModalTranslations;
    $[13] = selectedReason;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <div className={styles.listingReportModal_reasonsList}>{t5}</div>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== listingReportModalTranslations) {
    t7 = listingReportModalTranslations("placeholder");
    $[17] = listingReportModalTranslations;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== message || $[20] !== t7) {
    t8 = <textarea placeholder={t7} className={styles.listingReportModal_message} value={message} onChange={handleMessageChange} />;
    $[19] = message;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== actionsTranslations) {
    t9 = actionsTranslations("sent");
    $[22] = actionsTranslations;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== actionsTranslations) {
    t10 = actionsTranslations("send-message");
    $[24] = actionsTranslations;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== handleMessageSend || $[27] !== isSending || $[28] !== isSuccessSent || $[29] !== t10 || $[30] !== t9) {
    t11 = <div className={styles.listingReportModal_sendMessage}><Button element="button" size="md" fontSize="xs" onClick={handleMessageSend} fullWidth={true} isLoading={isSending} isSuccess={isSuccessSent} successMessage={t9}>{t10}</Button></div>;
    $[26] = handleMessageSend;
    $[27] = isSending;
    $[28] = isSuccessSent;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t4 || $[34] !== t6 || $[35] !== t8) {
    t12 = <div className={styles.listingReportModal}>{t4}{t6}{t8}{t11}</div>;
    $[32] = t11;
    $[33] = t4;
    $[34] = t6;
    $[35] = t8;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== isActive || $[38] !== onClose || $[39] !== t12) {
    t13 = <ModalOld onClose={onClose} isActive={isActive}>{t12}</ModalOld>;
    $[37] = isActive;
    $[38] = onClose;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
}
function _temp() {
  return null;
}